var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.36631C20 3.79291 19.8871 3.22514 19.6676 2.69539C19.4482 2.16565 19.1266 1.68431 18.7211 1.27886C18.3157 0.873412 17.8344 0.551793 17.3046 0.332365C16.7749 0.112938 16.2071 0 15.6337 0H4.36631C3.20829 0 2.0977 0.46002 1.27886 1.27886C0.460021 2.0977 0 3.20829 0 4.36631V9.29675C0 10.4548 0.460021 11.5654 1.27886 12.3842C2.0977 13.203 3.20829 13.6631 4.36631 13.6631H15.6105C16.1859 13.6661 16.7561 13.5554 17.2885 13.3374C17.821 13.1193 18.305 12.7982 18.713 12.3924C19.1209 11.9867 19.4446 11.5043 19.6654 10.973C19.8863 10.4418 20 9.8721 20 9.29675V4.36631ZM13.8176 6.96291L8.78671 9.44359C8.59351 9.55178 7.90572 9.44359 7.90572 9.18083V4.09583C7.90572 3.87172 8.59351 3.72488 8.79444 3.8408L13.5781 6.48377C13.779 6.56105 14.0031 6.85471 13.8176 6.96291Z",
    fill: "#7BC0EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterYoutube);
export default __webpack_public_path__ + "static/media/footer_youtube.7fb098630f00af78512649fa64dce79e.svg";
export { ForwardRef as ReactComponent };